import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IconsService {
  private _icons: { [iconName: string]: string } = {};

  constructor(
    private readonly httpClient: HttpClient
  ) { }

  getIcon(name: string, opt: { responseType: "text"; }): string | Promise<string> | Observable<string> {
    if (this._icons[name]) {
      return this._icons[name];
    }
    return this.httpClient
      .get(`/assets/icons/${name}.svg`, opt)
      .pipe(tap((icon) => {
        this._icons[name] = icon
      }));
  }
}
